import { Inject } from '@angular/core';
import templateSource from './app.component.html';
              import { Component, OnInit, ChangeDetectorRef, enableProdMode } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';
import { pagePermissionKey } from './page-policy';

@Component({
    standalone: false,
    selector: 'app-root',
template: templateSource || '',
    styles: [``],
})
export class AppComponent implements OnInit {
    public accessDenied = false;
    private authorizationVersion = 0;
    constructor(@Inject( Service)         public service: Service,@Inject( Router)         public router: Router,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( TranslateService    )         public translate: TranslateService    ) {
        const guarded = (routes: Routes): Routes => routes.map(route => ({
            ...route,
            ...(route.component && !route.children ? {
                canActivate: [...(route.canActivate || []), (_route, state) => this.authorize(state.url)],
                runGuardsAndResolvers: 'always' as const,
            } : {}),
            ...(route.children ? { children: guarded(route.children) } : {}),
        }));
        this.router.resetConfig(guarded(this.router.config));
        window['MonacoEnvironment'] = {
            getWorkerUrl: function (moduleId: string, label: string) {
                return `/lib/vs/base/worker/workerMain.js`;
            }
        };
    }

    private async authorize(url: string) {
        const version = ++this.authorizationVersion;
        const path = url.split(/[?#]/, 1)[0];
        if (path === '/access' || path === '/access/') {
            this.accessDenied = false;
            return true;
        }
        await this.service.auth.init(true);
        if (version !== this.authorizationVersion) return false;
        if (!this.service.auth.status) return this.router.parseUrl('/access');
        // Refresh on every navigation; the five-minute menu cache cannot authorize a page.
        await this.service.auth.loadPermissions(true);
        if (version !== this.authorizationVersion) return false;
        const key = pagePermissionKey(url);
        this.accessDenied = key === '!unmapped' || (key !== null && !this.service.auth.can(key, 'read'));
        this.ref.markForCheck();
        return !this.accessDenied;
    }

    public async ngOnInit() {
        enableProdMode();
        await this.service.init(this);
    }
}
